/** @module csi/datasheet/CreateAttributePlaceholder */
import Controller from "csi/action/Controller";
import card from "csi/card/_base";
import Key from "csi/core/Key";
import CanvasWidget from "csi/datasheet/CanvasWidget";
import CustomViewAttribute from "csi/middleware/customView/attributes/CustomViewAttribute";
import { routerStore } from "csi/state/rootStore";
import { DndStore } from "designSystem/dnd/index";
import declare from "dojo/_base/declare";
import AttributesPlaceholderStore from "./AttributesPlaceholderStore";

const CreateAttributePlaceholder = declare(Controller, {
	canvasType: "",
	store: null,
	groupObject: null,
	previousAttributeKeys: null,

	/**
	 * @override
	 * pickup possible existing attributes - edit existing placeholder case
	 */
	preProcess(): void {
		const store = this.store = new AttributesPlaceholderStore(
			this.canvasType,
			this.groupObject,
			this.previousAttributeKeys,
		);
		const { attributesStore } = store;

		// add dnd store
		const { canDrop } = attributesStore;
		const attributeDndStore = new DndStore<CustomViewAttribute>(canDrop);
		attributesStore.attributeDndStore = attributeDndStore;

		const popupProps = {
			onCancel: this.onCancel.bind(this),
			onSave: this.onSave.bind(this),
			onValidate: this.onValidate.bind(this),
			store: attributesStore,
			titleRes: "CreateAttributePlaceholder",
		};

		routerStore.openInlineDialog("csi/middleware/customView/attributes/AttributesDialog", popupProps);
	},
	
	/**
	 * Do nothing when edit cancelled
	 */
	onCancel(): void {
		this.closeAttributesDialog();
		this.postProcess();
	},

	/** validate the attribute placeholder dialog */
	async onValidate(): Promise<boolean> {
		const { attributesStore: { attributeKeys, loc } } = this.store;

		if (attributeKeys.length === 0) {
			throw new Error(loc.resource("CreateAttributePlaceholderRequiredError")); 
		}

		return true;
	},

	/**
	 * Convert selected attributes to extended keys and process
	 */
	onSave(): void {
		const { groupObject, previousAttributeKeys, store } = this;
		const { attributesStore } = store;
		const { attributeKeys } = attributesStore;
		const type = store.selectedType;
		var keys = attributeKeys.map((key) => new Key({ dpkey: key }));
		var specs = card.getAttributeCardSpecs(type, keys);
		var imageFlags = specs.attributeSpecs.map((spec) => spec.isImage());

		const view = this.widget as CanvasWidget;
		view.canvasWidgetNode.addPlaceholders({
			type,
			attributeKeys,
			imageFlags,
			groupObject,
			previousAttributeKeys,
		});

		this.closeAttributesDialog();
		this.process();
	},

	/** close popup */
	closeAttributesDialog(): void {
		routerStore.closeInlineDialog();
	},	
});

export = CreateAttributePlaceholder;
